import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * This interceptor removes custom headers from icon loader URL requests.
 * It should be registered LAST in the interceptor chain to clean up
 * headers added by other interceptors that are not needed for icon resources.
 */
@Injectable()
export class HttpExternalUrlCleanupInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if the URL is for the icon sprite from Cubivue assets
    const isIconUrl = req.url.includes('saas-ui-assets.cubivue.com');

    if (!isIconUrl) {
      // For other URLs, proceed normally
      return next.handle(req);
    }

    // For icon URLs, remove custom headers that were added by other interceptors
    const headersToRemove = [
      'clientId',
      'Ocp-Apim-Subscription-Key',
      'tenantId',
      'DistributionLanes',
      'Authorization',
    ];

    let cleanedRequest = req;

    // Clone the request and remove each custom header
    headersToRemove.forEach((headerName) => {
      if (cleanedRequest.headers.has(headerName)) {
        cleanedRequest = cleanedRequest.clone({
          headers: cleanedRequest.headers.delete(headerName),
        });
      }
    });

    return next.handle(cleanedRequest);
  }
}
